import UserProfile from "../../content/Profile/UserProfile/UserProfile"
import SidebarCard from "../SidebarCard/SidebarCard"
import community_icon from '../../../assets/images/community-icon.svg';
import calendar_icon from '../../../assets/images/calendar-icon.svg';
import { MyCommunityUsers } from "../../content/MyCommunityUsers/MyCommunityUsers";
import EventsItem from "../../content/Events/EventItem/EventItem";
import { SearchSideBar } from "../../content/SearchSideBar/SearchSideBar";
import './SideBar.scss'
import {useDispatch, useSelector} from "react-redux";
import { SidebarMenu } from "../SidebarMenu/SidebarMenu";
import { SidebarEventMenu } from "../SidebarEventMenu/SidebarEventMenu";
import { useLocation } from 'react-router-dom';
import moment from 'moment-timezone';
import {setCurrentUserClassList} from "../../../store/actions/current_userActions";
import {useEffect} from "react";

const SideBar = () => {

    const dispatch = useDispatch();
    const location = useLocation();

    const { currentPage, sidebarRouteData, currentCourse } = useSelector((state: any) => state.main)
    const { me } = useSelector((state: any) => state.auth);
    const {classList} = useSelector((state: any) => state.current_user);

    const userClassList = () => {
        const list = me?.classes?.filter((uclass: any) => uclass !== null)
            .filter((userclass: any) => moment(userclass.startDate).isAfter(moment().subtract(1, 'day')))
            .sort((a: any, b: any) => a.startDate > b.startDate ? 1 : -1);
        dispatch(setCurrentUserClassList(list));
    }

    useEffect(() => {
        if (me?.classes) {
            userClassList();
        }
    }, [me?.classes]);

    return currentPage !== "search" ? <div className="sidebar-wrapper">
        <SidebarCard
            type={'profile'}
            top={'0'}
        >
            <UserProfile />
        </SidebarCard>

        {currentPage === "coursePage" || currentPage === "coursePageLibrary"   ? <SidebarMenu iconSize={20} className={"sidebar-menu d-none d-md-block"} sidebarRouteData={sidebarRouteData} currentCourse={currentCourse} /> : null}

        {currentPage === "EventPage" || currentPage === "EventPageLibrary" || currentPage ==="EventParticipantsPage" ? <SidebarEventMenu iconSize={20} className={"sidebar-menu d-none d-md-block"} sidebarRouteData={sidebarRouteData} /> : null}

        {
            (location.pathname.includes('/my-campus/event/timeline') || location.pathname.includes('/my-feed')) ?
                <SidebarCard
                    className={''}
                    type={'community'}
                    top={'0'}
                    title={'My Hartman'}
                    highlightText={'Community'}
                    highlightColor={'#0089CE'}
                    icon={community_icon}
                    // btnText={'See all your friends'}
                >
                    <MyCommunityUsers path={location.pathname} />
                </SidebarCard> : null
        }    

        {
            location.pathname.includes('/shihr') ?
                <SidebarCard
                    className={''}
                    type={'community'}
                    top={'0'}
                    title={'Hartman HR'}
                    highlightText={'Community'}
                    highlightColor={'#0089CE'}
                    icon={community_icon}
                    // btnText={'See all your friends'}
                >
                    <MyCommunityUsers path={location.pathname} />
                </SidebarCard> : null
        }

        <SidebarCard
            type={'events'}
            top={'0'}
            title={'My'}
            highlightText={'Classes'}
            highlightColor={'#31AFC4'}
            icon={calendar_icon}
        >
            {classList?.filter((uclass: any) => uclass !== null)
                .filter((userclass: any) => moment(userclass.startDate).isAfter(moment().subtract(1, 'day')))
                .sort((a: any, b: any) => a.startDate > b.startDate ? 1 : -1)
                .map((userclass: any, index: number) => (
                <div key={index}>
                    <EventsItem userclass={userclass}  />
                </div>
            ))}
        </SidebarCard>
    </div> : <div className="search-sidebar-wrapper">
        <SearchSideBar />
    </div>
}

export default SideBar;